import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";
import Toggle from "../../Toggle/Toggle";

export default function NotifPrefRow({ pref }) {
  return (
    <div className={styles.notifPrefItem}>
      <div className={styles.notifPrefInfo}>
        <div className={styles.notifPrefLabel}>{pref.label}</div>
        <div className={styles.notifPrefDesc}>{pref.desc}</div>
      </div>
      <Toggle
        id={pref.id}
        ariaLabel={pref.label}
        defaultChecked={pref.defaultChecked}
      />
    </div>
  );
}
